import { AysDrgBaseRateService } from '@bindoc-projects/codes-lib/data';
import { BdPostalCodeService } from '@bindoc-projects/geographic-lib/data';
import { Injectable, inject } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, forkJoin, from, map, Observable } from 'rxjs';
import { AysDrgBaseRate } from '@bindoc-projects/code-domain-lib';

@Injectable({
  providedIn: 'root',
})
export class DependenciesService {
  private readonly _baseRateService = inject(AysDrgBaseRateService);
  private readonly _postalCodeService = inject(BdPostalCodeService);

  public fetchDependencies(): Observable<{
    postalCodeAdministrativeDistrictIdMap: { [postalCode: string]: number };
    drgBaseRates: { [year: string]: AysDrgBaseRate[] };
  }> {
    return forkJoin([
      this._fetchBaseRates().pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404) {
            throw new Error(`Endpunkt nicht gefunden: ${err.url} (HTTP 404)`);
          }
          throw new Error(
            `Basisfallwerte konnten nicht geladen werden (HTTP ${err.status})`,
          );
        }),
      ),
      this._fetchPostalCodeAdministrativeDistrictIdMap().pipe(
        catchError((err: HttpErrorResponse) => {
          if (err.status === 404) {
            throw new Error(`Endpunkt nicht gefunden: ${err.url} (HTTP 404)`);
          }
          throw new Error(
            `Postleitzahlen-Zuordnung konnte nicht geladen werden (HTTP ${err.status})`,
          );
        }),
      ),
    ]).pipe(
      map((responses) => {
        return {
          drgBaseRates: responses[0],
          postalCodeAdministrativeDistrictIdMap: responses[1],
        };
      }),
    );
  }

  private _fetchPostalCodeAdministrativeDistrictIdMap(): Observable<{
    [postalCode: string]: number;
  }> {
    return this._postalCodeService.administrativeDistrictMapping();
  }

  private _fetchBaseRates(): Observable<{ [year: string]: AysDrgBaseRate[] }> {
    return from(this._baseRateService.index());
  }
}
